/*
 * Some DOM query functions, inspired by jQuery
 */

function query(q) {
    return document.querySelectorAll(q);
}

/*
 * some shortcut functions, not related to the result of the query function
 */
query.on = (event, handler) => {
    window.addEventListener(event, handler);
};
query.off = (event, handler) => {
    window.removeEventListener(event, handler);
};
query.scrollTo = (target, start = false) => {
    let element = target;
    if (typeof target === 'string') {
        const elements = query(target);
        if (elements && elements.length > 0) {
            element = elements[0];
        } else {
            element = null;
        }
    }
    if (element) {
        element.scrollIntoView(start);
    }
};
query.scrollTop = () => {
    window.scrollTo(0, 0);
};
query.scrollUp = y => {
    window.scrollBy(0, y);
};
query.scrollDown = y => {
    window.scrollBy(0, -y);
};

export default query;
